import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    if (error.response?.status === 401 && !original._retry && !url.startsWith("/auth/")) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  },
);

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message === "Network Error" ? "Connection problem. Please try again." : "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ");
  return detail.msg || String(detail);
}

export function imageUrl(src) {
  if (!src) return null;
  if (src.startsWith("http") || src.startsWith("/brand")) return src;
  return `${API}/files/${src}`;
}

const DEFAULT_COVERS = {
  yacht: "/brand/yacht-v2.webp",
  villa: "/brand/villa-weekend.webp",
  chalet: "/brand/alpine-chalet.webp",
  jet: "https://images.unsplash.com/photo-1625513123245-fcb02d69ad12?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  dining: "https://images.unsplash.com/photo-1579027989536-b7b1f875659b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  events: "https://images.unsplash.com/photo-1630395822970-acd6a691d97e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  talent: "https://images.unsplash.com/photo-1541126274323-dbac58d14741?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  other: "/brand/planning-v2.webp",
};

export const coverOf = (exp) => imageUrl(exp?.cover || exp?.images?.[0] || exp?.stays?.find((s) => s.images?.length)?.images?.[0]) || DEFAULT_COVERS[exp?.type] || DEFAULT_COVERS.other;

export const TYPE_LABELS = { villa: "Villas", yacht: "Yachts", jet: "Private Jets", chalet: "Chalets", events: "Events & Nightlife", talent: "Private DJ/Talent Bookings", dining: "Dining", other: "Other" };
export const TYPE_SINGULAR = { villa: "Villa", yacht: "Yacht", jet: "Private Jet", chalet: "Chalet", events: "Event & Nightlife", talent: "DJ/Talent Booking", dining: "Dining", other: "Other" };
export const INTEREST_KEYS = ["villa", "yacht", "jet", "chalet", "events", "talent", "dining"];

export const STATUS = {
  draft: { label: "Draft", tone: "muted" },
  finding_cohosts: { label: "Finding co-hosts", tone: "emerald" },
  proposed_terms: { label: "Terms proposed", tone: "gold" },
  agreed: { label: "Plan agreed", tone: "emerald-solid" },
  closed: { label: "Closed", tone: "muted" },
  cancelled: { label: "Cancelled", tone: "red" },
};

export function formatDates(exp) {
  if (!exp?.start_date) return "Dates flexible";
  const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  const range = exp.end_date ? `${fmt(exp.start_date)} – ${fmt(exp.end_date)}` : fmt(exp.start_date);
  return exp.dates_flexible ? `${range} · flexible` : range;
}

export function money(amount, currency = "EUR") {
  if (amount == null) return "—";
  return new Intl.NumberFormat("en-GB", { style: "currency", currency, maximumFractionDigits: amount % 1 ? 2 : 0 }).format(amount);
}
